"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "lendinara": {
    "91c63a57": [{
      "hkey": "c3d03f77",
      "slug": "ramodipalo-rasa",
      "name": "Ramodipalo-Rasa",
      "primary": true,
      "skipSearch": false
    }],
    "ramodipalo": [{
      "hkey": "c3d03f77",
      "slug": "ramodipalo-rasa",
      "name": "Ramodipalo-Rasa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "db213c0a": [{
      "hkey": "c3d03f77",
      "slug": "ramodipalo-rasa",
      "name": "Ramodipalo-Rasa",
      "primary": true,
      "skipSearch": false
    }],
    "rasa": [{
      "hkey": "c3d03f77",
      "slug": "ramodipalo-rasa",
      "name": "Ramodipalo-Rasa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lendinara"
    }]
  }
};
exports["default"] = _default;